const ResearchPaperIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" fill="none">
		<path
			d="M8.66699 1.5V4.83333C8.66699 5.05435 8.75479 5.26631 8.91107 5.42259C9.06735 5.57887 9.27931 5.66667 9.50033 5.66667H12.8337M8.66699 1.5H2.83366C2.39163 1.5 1.96771 1.67559 1.65515 1.98816C1.34259 2.30072 1.16699 2.72464 1.16699 3.16667V14.8333C1.16699 15.2754 1.34259 15.6993 1.65515 16.0118C1.96771 16.3244 2.39163 16.5 2.83366 16.5H11.167C11.609 16.5 12.0329 16.3244 12.3455 16.0118C12.6581 15.6993 12.8337 15.2754 12.8337 14.8333V5.66667M8.66699 1.5L12.8337 5.66667M4.50033 13.1667H9.50033M4.50033 9.83333H9.50033"
			stroke="var(--black-color)"
			strokeOpacity="0.85"
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export default ResearchPaperIcon;
